import React from 'react';
import '../css/components/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <footer className="footer-container">
            <div className="container p-3 p-md-5">
                <div className="row">
                    {/* Logo Column */}
                    <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
                        <div className='text-center mb-3' style={{ marginTop: '-40px' }} >
                            <img
                                className="footer-logo"
                                src="/assets/Logo-01.png"
                                alt="Namaste Logo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection('home');
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className='text-center text-white fs-6 fs-md-5'>
                            <p>
                                Be a part of India's fastest growing chai brand and 
                                bring the authentic taste of tradition to every cup. 
                                Whether you're looking to start your own <b>NAMASTE CHAI </b> 
                                outlet or become a distributor, we provide the 
                                support, quality, and trust you need to succeed.
                            </p>
                        </div>
                    </div>

                    {/* Quick Links Column */}
                    <div className="col-lg-3 col-md-6 mb-4 mb-md-0 text-white">
                        <h4 className='mb-3 mb-md-4'>Quick Links</h4>
                        <ul className="footer-links list-unstyled">
                            <li className='mb-2 mb-md-3'>
                                <a href="#about" className="text-white" onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection('about');
                                }}>About Us</a>
                            </li>
                            <li className='mb-2 mb-md-3'>
                                <a href="#franchise" className="text-white" onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection('franchise');
                                }}>Franchise</a>
                            </li>
                            <li className='mb-2 mb-md-3'>
                                <a href="#distributorship" className="text-white" onClick={(e) => {
                                    e.preventDefault();
                                    scrollToSection('distributorship');
                                }}>Distributorship</a>
                            </li>
                            <li className='mb-2 mb-md-3'>
                                {/* <a href="#store" className="text-white" onClick={(e) => {
                                    e.preventDefault();
                                    // Note: You'll need to add an id="store" to your store section if you want this to work
                                    scrollToSection('outlet');
                                }}>Namaste Store</a> */}
                            <Link to="https://www.thenamastestore.com/" className="sidebar-logo text-white">Namaste Store</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Reach Us Column */}
                    <div className="col-lg-5 col-md-6 mb-4 mb-md-0 text-white">
                        <h4 className='mb-3 mb-md-4'>Reach Us</h4>
                        <div className='mb-3'>
                            <div className='d-flex gap-1'>
                                <div>
                                    <img
                                        className="footer-logo"
                                        src="/assets/icons/email.png"
                                        alt="Namaste Logo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollToSection('home');
                                        }}
                                        style={{ cursor: 'pointer', height: '40px', width: '40px' }}
                                    />
                                </div>
                                <div>
                                    <a href="tel:+91836938902" className="text-white">sales@namastechai.in</a>
                                </div>
                            </div>
                            {/* <a href="https://namastechai.in/" 
                                className="text-white" 
                                // target="_blank" 
                                // rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.open('https://namastechai.in/', '_blank');
                                }}
                            >
                                https://namastechai.in/
                            </a> */}
                            {/* <Link to="https://www.thenamastestore.com/" className="sidebar-logo text-white">https://www.thenamastestore.com/</Link> */}

                        </div>
                        <div className='d-flex gap-1'>
                            <div>
                                <img
                                    className="footer-logo"
                                    src="/assets/icons/address.png"
                                    alt="Namaste Logo"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToSection('home');
                                    }}
                                    style={{ cursor: 'pointer', height: '40px', width: '40px' }}
                                />
                            </div>
                            <div>
                                <address className='mb-3 fs-6 fs-md-5'>
                                    A/501, Oberoi Chambers,<br />
                                    Off New Link Road, Veera<br />
                                    Desai Industrial Estate, Andheri<br />
                                    West, Mumbai 400053,<br />
                                    Maharashtra, India.
                                </address>
                            </div>
                        </div>
                        
                        <div className='fs-6 fs-md-5'>
                            <div className='d-flex gap-1'>
                                <div>
                                    <img
                                        className="footer-logo"
                                        src="/assets/icons/contact.png"
                                        alt="Namaste Logo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            scrollToSection('home');
                                        }}
                                        style={{ cursor: 'pointer', height: '40px', width: '40px' }}
                                    />
                                </div>
                                <div>
                                    <a href="tel:+919817656667" className="text-white d-block">+91 98176 56667</a>
                                    <a href="tel:+91836938902" className="text-white">+91 83693 89023</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    {/* Contact Form Column */}
                    {/* <div className="col-lg-3 col-md-6">
                        <div className='card p-3 p-md-4 footer-form'>
                            <h5 className='mb-3' style={{ color: 'brown' }}>Get in Touch</h5>
                            <form>
                                <div className="mb-3">
                                    <input type="text" className="form-control form-control-sm" placeholder="Name" required />
                                </div>
                                <div className="mb-3">
                                    <input type="email" className="form-control form-control-sm" placeholder="Email" required />
                                </div>
                                <div className="mb-3">
                                    <input type="tel" className="form-control form-control-sm" placeholder="Phone Number" required />
                                </div>
                                <div className="mb-3">
                                    <input type="text" className="form-control form-control-sm" placeholder="Place" required />
                                </div>
                                <button type="submit" className="btn btn-primary w-100">
                                    Submit
                                </button>
                            </form>
                        </div>
                    </div> */}
                </div>

                {/* Copyright Section */}
                <div className="row mt-4">
                    <div className="col-12 text-center text-white">
                        <p className="mb-0">&copy; {new Date().getFullYear()} Namaste Chai. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;